export default "__VITE_ASSET__C$o5CUNK__"